<template>
  <div class="stacked-bar">
    <div
      v-if="!hidePercentage"
      class="stacked-bar__percentage"
    >
      <span
        v-for="(barPercentage, index) in dataset.percentage"
        :key="index"
      >
        {{ barPercentage | percentage }}
      </span>
    </div>

    <div
      class="stacked-bar__bars"
      :class="{ 'stacked-bar__bars--empty': isEmptyBars }"
    >
      <div
        v-for="(barPercentage, index) in dataset.percentage"
        :key="index"
        :style="`width: ${barPercentage}%;`"
        v-show="barPercentage"
      />
    </div>

    <div
      v-if="!hideLabel"
      class="stacked-bar__label"
    >
      <span
        v-for="(label, index) in dataset.label"
        :key="index"
      >
        {{ label }}
      </span>
    </div>

    <div
      v-if="!hideLegend"
      class="stacked-bar__legend"
    >
      <span
        v-for="(legend, index) in dataset.legend"
        :key="index"
      >
        {{ legend }}
      </span>
    </div>
  </div>
</template>

<script>
import { numberFilter, percentageFilter } from '@/utils/filters'

export default {
  name: 'BaseStackedBar',

  filters: {
    number: numberFilter,
    percentage: percentageFilter
  },

  props: {
    dataset: {
      type: Object,
      required: true
    },
    hidePercentage: Boolean,
    hideLabel: Boolean,
    hideLegend: Boolean
  },

  computed: {
    isEmptyBars () {
      return this.dataset.percentage.every(item => item === 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.stacked-bar {
  $color-primary: nth($colors-custom, 1);
  $color-secondary: nth($colors-custom, 2);
  $color-muted: nth($colors-custom, 4);

  line-height: 120%;

  &__percentage {
    display: flex;
    justify-content: space-between;

    span {
      font: {
        weight: 600;
        size: 14px;
      }
    }
  }

  &__bars {
    display: flex;
    height: 12px;
    gap: 5px;
    margin-top: 5px;

    &--empty {
      div {
        display: none;
      }

      &::before {
        content: '';
        width: 100%;
        height: 100%;
        border-radius: 2em;
        background: $color-muted;
      }
    }

    div {
      height: 100%;
      border-radius: 2em;

      &:first-child {
        background: $color-primary;
      }

      &:last-child {
        background: $color-secondary;
      }
    }
  }

  &__label {
    display: flex;
    justify-content: space-between;
    margin-top: 5px;

    span {
      font: {
        weight: 400;
        size: 11px;
      }
    }
  }

  &__legend {
    display: flex;
    gap: 10px;
    margin-top: 10px;

    span {
      display: flex;
      align-items: center;
      gap: 3px;

      font: {
        weight: 600;
        size: 12px;
      }

      &::before {
        content: '';
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 1rem;
      }

      &:first-child {
        &::before {
          background: $color-primary;
        }
      }

      &:last-child {
        &::before {
          background: $color-secondary;
        }
      }
    }
  }
}
</style>
